module.exports = __webpack_public_path__ + "static/media/home-hero@2x.7e38c539.jpg";